module.exports = __webpack_public_path__ + "img/12.ee5c6e50.jpg";